import React, { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./i18n";

export const LanguageContext = createContext();

const applyDocumentDir = (lang) => {
  try {
    const safe = lang === "ar" ? "ar" : "en";
    document.documentElement.setAttribute("lang", safe);
    document.documentElement.setAttribute("dir", safe === "ar" ? "rtl" : "ltr");
  } catch (_) {}
};

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language || "en");

  useEffect(() => {
    applyDocumentDir(i18n.language);
    const handler = (lng) => {
      applyDocumentDir(lng);
      setLanguage(lng);
    };
    i18n.on("languageChanged", handler);
    return () => i18n.off("languageChanged", handler);
  }, [i18n]);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <LanguageContext.Provider
      value={{
        language,
        changeLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
